import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useNavigate } from "react-router-dom";
import 'reactjs-popup/dist/index.css';
import { Modalcarga } from '../Modales/Modalcarga';
import Spinner from '../commons/Spinner';
import { EqHoja } from './EqHoja';
import Sign from './Sign';
import { Alertassw } from '../Alertas/Alertassw';
import { actualizarOt, actualizarEntrega, getDataObtenerUno, requestFirmaRemotaHT } from '../../api/common';
import { useAuth } from "../../hooks/useAuth";
import { PdfOt } from './PdfOt';
import ModalFirmaRemota from '../OtSelect/ModalFirmaRemota';


export const  Otsonpdf =({cambiarestado,refresh,setRefresh, otFath, EqSedeFilter, obsGen, sitioSeleted, sedeSeleted, sedes, mode='ot', programData, SetModalcharge})=> {
  

  const navigate = useNavigate();
  const [ estadomodalIn,setEstadomodalIn ] = useState(false)
  const [datason, setDatason]=useState({})
  const { userData } = useAuth();
  const [responsablesSeleccionados, setResponsablesSeleccionados] = useState([
    {id:userData._id,
      nombre:userData.nombre,
      apellido:userData.apellido
    }
  ]);  //Usuarios seleccionados para filtrar los equipos de la OT
  const [estadofirma, setEstadofirma]=useState(false)
  const [status, setStatus] = useState(null);
  const [statusVer, setStatusVer]=useState(false);
  const [estadoSig, setEstadoSig]=useState(false)
  const [firmaUser, setFirmaUser]=useState();
  const [responsables, setResponsables]=useState();
  const [showFirmaModal, setShowFirmaModal]=useState(false);
  const [loadingFirma, setLoadingFirma]=useState(false);
  const [obsGenLocal, setObsGenLocal]=useState('');
  const [showEqObs, setShowEqObs]=useState(false);

  const sede= useCallback(()=>{
    const sedeObj = sedes?.find(s => s._id === sedeSeleted)
      || sedes?.find(s => s.nameSede === 'Principal')
      || sedes?.[0]
      || null;
    return sedeObj|| null;
  },[sedes, sedeSeleted])



  const handleCheckboxChange = (responsable) => {
    setResponsablesSeleccionados((prev) => {
      // Si ya está en la lista, lo quitamos
      if (prev.some(r => r.id === responsable.id)) {
        return prev.filter(r => r.id !== responsable.id);
      } else {
        // Si no está, lo agregamos
        return [...prev, responsable];
      }
    });
  };
  
  const finalizarOt=()=>{
      // cambio el estado a finalizados para enviar al servidor.
      for(let i=0; i<datason.equipos.length; i++){
        if(datason.equipos[i].estado==='Procesado'){
          datason.equipos[i].estado='Finalizado'
        }
        if(datason.equipos[i].estado==='Pendiente'){
          datason.equipos[i].estado='Aplazado'
        }
      }
    async function putOt(){
      setEstadomodalIn(true)
      SetModalcharge?.(true)
      datason.entregado={
        firma:firmaUser._id,
        persona:userData?.nombre +" "+ userData?.apellido, 
        cargo:userData?.role?.nombre, 
        fecha: new Date(), 
      }
      let ota;
      if (mode === 'programacion') {
        programData.equipos = datason.equipos
        programData.observacion = datason.observacion
        programData.sedeCliente = sede()?._id || null
        programData.entregado = datason.entregado
        ota = await actualizarEntrega("Programacion", programData, programData._id)
      } else {
        ota = await actualizarOt("Ot", datason, datason._id)
      }
      if(ota.status===200){
        setStatus('entregado')
        //setEstadoSig(true)
        setEstadomodalIn(false)
        SetModalcharge?.(false)
        if (mode === 'ot') {
          setRefresh(!refresh)
          const dataot=ota.data.data;
          console.log(dataot)
          PdfOt(dataot, dataot.entregado.firma, dataot.recibido.firma,false)
        } else {
          setRefresh?.()
        }
        Alertassw('toast','Se ha finalizado la Orden trabajo correctamente')
        setEstadofirma(false);
        Alertassw("success", "OT Firmada Exitosamente");
        cambiarestado(false)
      }
    }
    putOt()
  }

  const Firmar=()=>{
    setEstadoSig(true)
    setEstadofirma(true);
  }

  /**
   * Abrir modal para confirmar email de firma remota
   */
  const handleCerrarSinFirma = () => {
    setShowFirmaModal(true);
  }

  /**
   * Solicitar firma remota - envía email al cliente
   */
  const handleSolicitarFirma = async (email) => {
    try {
      
      setLoadingFirma(true);
      setEstadomodalIn(true);
      
      // Cambiar estados: Procesado → Finalizado, Pendiente → Aplazado
      for (let i = 0; i < datason.equipos.length; i++) {
        if (datason.equipos[i].estado === 'Procesado') {
          datason.equipos[i].estado = 'Finalizado'
        }
        if (datason.equipos[i].estado === 'Pendiente') {
          datason.equipos[i].estado = 'Aplazado'
        }
      }
      
      // Actualizar OT/Programacion con firma del técnico
      datason.entregado = {
        firma: firmaUser._id,
        persona: userData?.nombre + " " + userData?.apellido,
        cargo: userData?.role?.nombre,
        fecha: new Date()
      }
      
      let ota;
      if (mode === 'programacion') {
        programData.equipos = datason.equipos
        programData.observacion = datason.observacion
        programData.sedeCliente = sede()?._id || null
        programData.entregado = datason.entregado
        SetModalcharge?.(true)
        ota = await actualizarEntrega("Programacion", programData, programData._id)
      } else {
        ota = await actualizarOt("Ot", datason, datason._id)
      }
      
      
      if (ota.status === 200) {
        // Extraer el Child creado desde la respuesta del backend
        const htCreada = ota.data.data;
        
             
        try {
          // Solicitar firma remota para la Hoja de Trabajo completa (UN solo email)
          // USAR EL ID DEL CHILD, NO DEL PARENT
          const resultadoFirma = await requestFirmaRemotaHT(htCreada._id, email)
          
          console.log('📊 [Otsonpdf] Resultado solicitud firma:', resultadoFirma)
          
          if (resultadoFirma.status === 200) {
            console.log('✅ [Otsonpdf] Email de firma remota enviado exitosamente')
            Alertassw('success', 'Hoja de Trabajo cerrada', `Se ha enviado un correo a ${email} con el enlace para firmar la confirmación de servicio.`);
          } else {
            console.error('❌ [Otsonpdf] Error al enviar email de firma. Status:', resultadoFirma.status)
            Alertassw('warning', 'HT cerrada pero email falló', `La Hoja de Trabajo fue cerrada, pero hubo un problema al enviar el email de firma.`);
          }
        } catch (errorFirma) {
          console.error('❌ [Otsonpdf] Error al solicitar firma remota:', errorFirma)
          Alertassw('warning', 'HT cerrada pero email falló', `La Hoja de Trabajo fue cerrada, pero hubo un problema al enviar el email de firma.`);
        }
        
        setLoadingFirma(false);
        setEstadomodalIn(false);
        SetModalcharge?.(false)
        setShowFirmaModal(false);
        if (mode === 'ot') setRefresh(!refresh);
        else setRefresh?.();
        cambiarestado(false);
      } else {
        console.error('❌ [Otsonpdf] Error al actualizar OT/Programacion. Status:', ota.status)
        setLoadingFirma(false);
        setEstadomodalIn(false);
        SetModalcharge?.(false)
        Alertassw('error', 'Error al actualizar OT', 'Revise la consola');
      }
    } catch (error) {
      console.error('❌ [Otsonpdf] Error al solicitar firma remota:', error);
      setLoadingFirma(false);
      setEstadomodalIn(false);
      Alertassw('error', 'Error al enviar solicitud', error.message || 'Contacte a soporte técnico');
    }
  }
  useEffect(() => {
    if (!EqSedeFilter) return; // Evita errores si EqSedeFilter es undefined

    const equiposFiltrados = EqSedeFilter.filter((eqEnd) => 
      (eqEnd.estado === "Procesado" || eqEnd.estado === "Cancelado" || eqEnd.estado === "Pendiente") &&
      eqEnd.responsable && // Verifica que eqEnd.responsable no sea undefined
      responsablesSeleccionados.some(selected => selected.id === eqEnd.responsable._id)
    );  
    const observacion =unirobs(equiposFiltrados,obsGenLocal)

    setDatason({
      ...datason,
      equipos:equiposFiltrados,
      observacion:observacion,
      sedeCliente: sede(),
    })    /// Seteo los equipos a la hoja de trabajo de acuerdo a los usuarios seleccionados

  }, [responsablesSeleccionados, obsGenLocal]); // Agrega EqSedeFilter como dependencia para evitar errores
  
  useEffect(()=>{
    const equiposFiltrados = EqSedeFilter.filter((eqEnd) => 
      (eqEnd.estado === "Procesado" || eqEnd.estado === "Cancelado" || eqEnd.estado === "Pendiente") &&
      eqEnd.responsable && // Verifica que eqEnd.responsable no sea undefined
      responsablesSeleccionados.some(selected => selected.id === eqEnd.responsable._id)
    ); 

    const observacion = obsGenLocal

    const responsablesUnicos = Array.from(   //Calcula los resposanbles disponibles 
      new Map(
        otFath.equipos
          .filter(eq => eq.responsable && !eq.fechaCalibracion) // Filtra equipos con responsable y sin fechaCalibracion
          .map(eq => [
            eq.responsable._id, 
            {
              id: eq.responsable._id,
              nombre: eq.responsable.nombre,
              apellido: eq.responsable.apellido.charAt(0) // Solo la primera letra del apellido
            }
          ])
      ).values()
    );
    setResponsables(responsablesUnicos)   //Carga el array de los responsables 
    const sedeObj = sedes?.find(s => s._id === sedeSeleted)
      || sedes?.find(s => s.nameSede === 'Principal')
      || sedes?.[0]
      || null;
    setDatason({
      _id:otFath._id,
      idFath:otFath._id,
      numeroOrden :otFath.numeroOrden,
      sede:otFath.sede,
      sedeCliente: sedeObj || null,
      visitas:otFath.visitas,
      observacion:'',
      equipos:equiposFiltrados,
      observacion:observacion,
      cliente:otFath.cliente,
      sitioCal:sitioSeleted||'Sitio'

    })

async function consultarSing(){   //Consulta firma
    const signDb = await getDataObtenerUno("sign", {
      user: userData._id,
    });
    // En mode='ot' re-fetch del cliente; en mode='programacion' ya viene en otFath
    if (mode === 'ot') {
      const Otfath = await getDataObtenerUno("Ot", {
        _id: otFath._id,
      });
      if(Otfath.status==200){
        datason.cliente=Otfath.data.data.cliente
      }
    }
    setFirmaUser(
      signDb.data.data
    )
    if(signDb.status==200){
      setStatusVer(true);
      datason.entregado={
        firma:signDb.data.data._id,
        persona:userData.nombre+" "+userData.apellido,
        cargo:userData.role.nombre,
        fecha:new(Date) 
      }
    }
  }
  consultarSing()
  },[])

  if(status=== "fin entrega"){
    cambiarestado(false)
    Alertassw('ok', 'Has creado un hoja de trabajo','Descarga en proceso' )
    navigate(`/Ot`);
  }

  return (
    <div >
      <Modalcarga
        estadoIn={estadomodalIn} 
        cambiarestadoIn={setEstadomodalIn}
        >
          <Spinner />
      </Modalcarga>
      <div className="container w-100">
        <div className="row mb-2">
          <div className="col">
            <textarea
              className="form-control"
              placeholder="Agregar observación general..."
              rows={2}
              value={obsGenLocal}
              onChange={e => setObsGenLocal(e.target.value)}
            />
            {datason?.equipos?.some(e => e.observacion) && (
              <div className="mt-1">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary mt-1"
                  onClick={() => setShowEqObs(s => !s)}
                >
                  <i className={`bi bi-chevron-${showEqObs ? 'up' : 'down'} me-1`}/>
                  Obs. individuales ({datason.equipos.filter(e => e.observacion).length})
                </button>
                {showEqObs && (
                  <ul className="list-group mt-2">
                    {datason.equipos.filter(e => e.observacion).map(e => (
                      <li key={e._id} className="list-group-item list-group-item-light py-1 small">
                        <strong>{e.equipo?.item?.nombre} – {e.consecutivo}:</strong> {e.observacion}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="row align-items-center p-3 border">
          {/* Botones alineados a la izquierda */}
          <div className="col-auto">
            {status === "entregado" ? null : (
              <>
                <button onClick={Firmar} className="btn btn-primary me-2">
                  <i className="bi bi-pen me-1"/>
                  Finalizar con Firma
                </button>
                <button onClick={handleCerrarSinFirma} className="btn btn-outline-primary me-2">
                  <i className="bi bi-check-circle me-1"/>
                  Cerrar sin Firma Cliente
                </button>
              </>
            )}
            {statusVer === false ? null : (
              <button onClick={() => PdfOt(datason, firmaUser, "", true)} className="btn btn-secondary">Ver hoja</button>
            )}
          </div>

          {/* Checkboxes alineados a la derecha */}
          <div className="col text-end">
            {responsables?.map(responsable => {
               // Verificar si el responsable coincide con userData por ID o identificación
              const esUsuarioActual = responsable.id === userData._id || responsable.identificacion === userData.identificacion;
              return(
              <div key={responsable.id} className="form-check d-inline-block me-3">
                <input 
                  type="checkbox" 
                  id={responsable.id} 
                  className="form-check-input"
                  onChange={() => handleCheckboxChange(responsable)}
                  checked= {esUsuarioActual? esUsuarioActual:null} // Si es el usuario actual, marcarlo como seleccionado
                  disabled={esUsuarioActual} // Si es el usuario actual, deshabilitarlo
                />
                <label htmlFor={responsable.id} className="form-check-label ms-1">
                  {`${responsable.nombre} ${responsable.apellido}.`}
                </label>
              </div>
            );
            })}
          </div>
        </div>
      </div>
        <EqHoja datason={datason}/> 
       {estadoSig?
        <Sign 
        singWindow={estadofirma}  
        setSignWindow={setEstadofirma} 
        type={"ambos"} 
        ot={datason} 
        onStatus={(status)=>setStatus(status)} 
        finalizarOt={finalizarOt}
        firmaUser={firmaUser}/>:
        <></>
       }

        <ModalFirmaRemota
          show={showFirmaModal}
          onHide={() => setShowFirmaModal(false)}
          equipos={datason.equipos}
          ots={otFath}
          onSolicitar={handleSolicitarFirma}
          loading={loadingFirma}
        />
        </div>
  )
}


export const unirobs=(filtradoFinalizar, obsGen)=>{
  var observaciones=''
  var j=1;
  if(obsGen){
    var observaciones =j+") "+obsGen+".\n"
    j++
  }
  for(var i=0; i<filtradoFinalizar.length; i++){
    if(filtradoFinalizar[i]?.observacion){
      var observaciones = observaciones +""+j +") " + filtradoFinalizar[i]?.equipo.item.nombre +" - "+
      filtradoFinalizar[i]?.consecutivo+" "+ filtradoFinalizar[i]?.observacion+ ".\n"
      j++;
    }
  }
  return observaciones
}